import {Component,OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Axe5DTO} from "@domain/admin/entreprise/analytique/axe5Dto";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'affichage d'un référentiel Axe 5 dans la liste de tous les référentiels
 */
@Component({
	host: {'data-test-id': 'analytique-axe5-item'},
	selector: 'analytique-axe5-item',
	templateUrl: './analytique-axe5-item.component.html'
})
export class AnalytiqueAxe5ItemComponent extends ListViewItem<Axe5DTO> implements OnInit {
	/** Liste des types de filtre présents */
	filtres: string;

	/**
	 * Constructeur
	 *
	 * @param router Router de l'application
	 * @param translateService Service des traductions
	 */
	constructor(
		private router: Router,
		private translateService: TranslateService
	) {
		super();
	}

	/**
	 * Initialisation
	 */
	ngOnInit() {
		//Initialisation de la liste des filtres
		let listeFiltres = new Array<String>();

		if (this.data.filtreDossier) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe5.infos.filtre.cc')); }
		if (this.data.filtreMotCle) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe5.infos.filtre.mc')); }
		if (this.data.filtreOrga) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe5.infos.filtre.se')); }
		if (this.data.filtreTypeEntite) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe5.infos.filtre.te')); }

		//Initialisation de la string à afficher
		this.filtres = listeFiltres.join(', ')
		listeFiltres.length = 0;
	}

	/**
	 * Méthode appelée lors de la sélection d'un référentiel Axe 5
	 */
	onSelect() {
		//Navigation vers la page d'informations du référentiel
		this.router.navigate(['Admin/Entreprise/Analytique/Axe5/' + this.data.idAxe5]);
	}
}